function injectStyle (ssrContext) {
  require("!!../../node_modules/.2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/.12.2.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-75548505\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/.12.2.2@vue-loader/lib/selector?type=styles&index=0!./Layout.vue")
}
var Component = require("!../../node_modules/.12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.12.2.2@vue-loader/lib/selector?type=script&index=0!./Layout.vue"),
  /* template */
  require("!!../../node_modules/.12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-75548505\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../node_modules/.12.2.2@vue-loader/lib/selector?type=template&index=0!./Layout.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Layout.vue
// module id = 7
// module chunks = 0